import React, { useContext } from 'react';
import Icon from '../../../components/icon/Icon';
import Popovers from '../../../components/bootstrap/Popovers';
import SocketContext from '../../../contexts/socketContext';

const SocketStatusIndicator: React.FC = () => {
	const { socket } = useContext(SocketContext);
	
	const isConnected = socket?.connected || false;

	return (
		<>
			<Popovers
				trigger='hover'
				desc={isConnected ? 'QR Scanner Active - Ready to receive customer scans' : 'QR Scanner Disconnected'}>
				<div
					className='d-flex align-items-center gap-2 px-3 py-2 rounded'
					style={{
						backgroundColor: isConnected ? 'rgba(34, 197, 94, 0.1)' : 'rgba(239, 68, 68, 0.1)',
						cursor: 'default',
					}}>
					<div
						className='position-relative'
						style={{
							width: '10px',
							height: '10px',
							backgroundColor: isConnected ? '#22c55e' : '#ef4444',
							borderRadius: '50%',
						}}>
						{isConnected && (
							<span
								className='position-absolute top-50 start-50 translate-middle pulse-ring-animation'
								style={{
									width: '20px',
									height: '20px',
									backgroundColor: '#22c55e',
									borderRadius: '50%',
									opacity: 0.5,
								}}
							/>
						)}
					</div>
					<div className='d-flex align-items-center gap-2'>
						<Icon icon='QrCodeScanner' size='lg' color={isConnected ? 'success' : 'danger'} />
						<span
							className='small fw-medium'
							style={{ color: isConnected ? '#22c55e' : '#ef4444' }}>
							{isConnected ? 'Scan Ready' : 'Offline'}
						</span>
					</div>
				</div>
			</Popovers>

			<style>{`
				@keyframes pulse-ring {
					0% {
						transform: translate(-50%, -50%) scale(0.5);
						opacity: 0.5;
					}
					50% {
						transform: translate(-50%, -50%) scale(1);
						opacity: 0.3;
					}
					100% {
						transform: translate(-50%, -50%) scale(1.5);
						opacity: 0;
					}
				}

				.pulse-ring-animation {
					animation: pulse-ring 2s infinite;
				}
			`}</style>
		</>
	);
};

export default SocketStatusIndicator;
